'use client'
import { FC, ReactNode, useEffect } from 'react'
type ShopifyAgenturLayoutProps = {
  children: ReactNode
}
const ShopifyAgenturLayout: FC<ShopifyAgenturLayoutProps> = ({ children }) => {
  useEffect(() => {
    document.body.setAttribute('data-theme', 'KMRS-Shopify')

    return () => {
      document.body.removeAttribute('data-theme')
    }
  }, [])
  return children
}

export default ShopifyAgenturLayout
